import { useScreenSize } from '../custom-hooks/useScreenSize';

export const useNumberOfProducts = (): number => {
  const { isXXXLarge, isXXLarge, isXLarge, isLarge } = useScreenSize();
  const isDesktopAndAbove = isXXXLarge || isXXLarge || isXLarge || isLarge;
  const numberOfProducts = isDesktopAndAbove ? 15 : 12;
  return numberOfProducts;
};
